import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "carouselVideos",
  class: "carousel carousel-dark carousel-fade slide d-flex d-flex align-items-stretch h-100",
  "data-bs-ride": "carousel",
  "data-bs-interval": "10000"
}
const _hoisted_2 = { class: "carousel-inner my-auto" }
const _hoisted_3 = ["data-bs-interval"]
const _hoisted_4 = { class: "ratio ratio-16x9" }
const _hoisted_5 = ["src", "title"]
const _hoisted_6 = { class: "flex-fill d-flex justify-content-center mt-0 mb-1" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlist, (video, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass([
          { 'carousel-item': true, active: index === 0 },
          video.button && video.button?.visible ? 'px-5' : 'video-padding',
        ]),
          "data-bs-interval": video.interval || '10000'
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("iframe", {
              width: "1920",
              height: "1080",
              src: video.src,
              title: video.title,
              id: "vimeoPlayer",
              frameborder: "0",
              allow: "autoplay; fullscreen; picture-in-picture",
              allowfullscreen: ""
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(video.button && video.button?.visible ? 'd-flex' : 'd-none')
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                href: video.button?.href,
                target: "_blank",
                type: "button",
                class: "btn btn-outline-primary btn-sm mt-1"
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["me-2", video.button?.icon])
                }, null, 2),
                _createTextVNode(_toDisplayString(video.button?.title), 1)
              ], 8, _hoisted_7)
            ])
          ], 2)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    (_ctx.playlist.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createStaticVNode("<button class=\"carousel-control-prev w-auto\" type=\"button\" data-bs-target=\"#carouselVideos\" data-bs-slide=\"prev\" data-v-01bf5fb2><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-01bf5fb2></span><span class=\"visually-hidden\" data-v-01bf5fb2>Previo</span></button><button class=\"carousel-control-next w-auto\" type=\"button\" data-bs-target=\"#carouselVideos\" data-bs-slide=\"next\" data-v-01bf5fb2><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-01bf5fb2></span><span class=\"visually-hidden\" data-v-01bf5fb2>Siguiente</span></button>", 2))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}